import moment from "moment";
import { boolean, object, string } from "yup";

export const subscriberValidations = object({
  first_name: string().required("First name is required"),
  last_name: string().required("Last name is required"),
  email: string()
    .required("Email is required")
    .email("Invalid email")
    .test("pattern", "Email is not valid", (value) => {
      return Boolean(
        value &&
          /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,12}$/.exec(value)
      );
    }),
  phone: string()
    .required("Phone number is required")
    .length(10, "Phone number must be 10 digits"),
  lease_end_date: string()
    .test(
      "optional-if-month-to-month",
      "Lease end date is required",
      function (value) {
        return this.parent.lease_month_to_month || value;
      }
    )
    .test(
      "ongoing-lease",
      "Lease end date must be in the the future",
      function (value) {
        return this.parent.lease_month_to_month || !value
          ? true
          : moment(value).isSameOrAfter(moment().subtract(1, "day"));
      }
    ),
  lease_month_to_month: boolean(),
  monthly_rent_amount: string().required("Rent amount is required"),
  dob: string()
    .required("Date of birth is required")
    .test(
      "must_be_18_years_old",
      "Must be at least 18 years old",
      function (value) {
        return moment().diff(moment(value), "years") >= 18;
      }
    )
    .test("dob", "Invalid date of birth", function (value) {
      return value ? moment(value).isValid() : true;
    })
});
